import './filtersGrid.scss';

const FiltersGrid = ({ searchInputRef, searchTerm, onSearch, onClose }) => {
  return (
    <div className="filtersGrid">
      <div className="filtersGrid__search">
        <input
          ref={searchInputRef}
          type="text"
          placeholder="Buscar zona..."
          defaultValue={searchTerm}
          onKeyUp={(e) => {
            if (e.key === 'Enter') onSearch();
          }}
          className="filtersGrid__input"
        />
        <button
          type="button"
          className="filtersGrid__btn filtersGrid__btn--search"
          onClick={onSearch}
        >
          🔍
        </button>
        {searchTerm && (
          <button
            type="button"
            className="filtersGrid__btn filtersGrid__btn--clear"
            onClick={onClose}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default FiltersGrid;
